/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

define([
  "backbone",
  "moment",
  "underscore",
  "messaging/messenger",
  "modules/reportSplit/reports/singleReport/reportUtilities",
], function (Backbone, Moment, _, Messenger, ReportUtilities) {
  "use strict";

  const ConfigAreaModel = {};

  function isChart(reportType, reportHref) {
    if (!reportType) {
      return false;
    }
    switch (reportType.toLowerCase()) {
      case "bar":
      case "column":
      case "line":
      case "multiline":
      case "pie":
      case "stackedcolumn":
        return true;
      case "singlenumber":
      case "table":
        return false;
      default:
        if (
          reportHref &&
          (reportHref.startsWith("/trendingII") || reportHref.startsWith("/scatterplot"))
        ) {
          return true;
        }
        console.error(
          "Unknown if report contains a chart, type=" + reportType + ", href=" + reportHref,
        );
        return false;
    }
  }

  ConfigAreaModel.configArea = Backbone.Model.extend({
    configure: function (configEntries, report) {
      let hasStartDate = false;
      let hasEndDate = false;
      let hasTouchpoints = false;
      let hasStandardResponses = false;
      let hasCategories = false;
      let hasSnippet = false;
      let hasTopic = false;
      let hasIntervals = false;
      let hasLanguages = false;
      let hasMultipleLanguages = false;
      let selectedLanguages = [];
      let hasAgents = false;
      let hasMatchType = false;
      let hasStatusId = false;
      let catVal = null;
      let catValDisplay = null;
      let category = null;
      let startDate = null;
      let startDateMonth = null;
      let startDateYear = null;
      let endDateMonth = null;
      let endDateYear = null;
      let surveyChoice = null;
      let reasonWithOrWithout = null;
      let endDate = null;
      let matchType = null;
      let statusId = null;
      let limitToMonths = false;
      let limitToYears = false;
      let hasAbbreviatedOption = false;
      let isAbbreviated = false;
      let bucket = null;
      let escalation = null;
      let snippetId = null;
      let topic = null;
      let selectedTouchpoint = Messenger.reqres.request("default:touchpoint");
      let selectedTouchpoints = [];
      let selectedStandardResponse = null;
      let selectedSites = [];
      let interval = null;
      const hasConfigEntries = configEntries.length > 0;
      let showDownloadCharts = false;
      let showIncludeFinished = false;
      let isFinished = false;
      let hasShowBlankResponses = false;
      let isShowBlankResponses = false;
      let hasTopicStatuses = false;
      let showTopicScheduledStatuses = false;
      let selectedTopicStatuses = [];
      let selectedTopicScheduledStatuses = [];
      const kb = Messenger.reqres.request("active:kb:model");
      const kbId = kb.get("kbId") || Messenger.reqres.request("active:kb");
      const topicStatuses = Messenger.reqres.request("kb:statuses").get("allTopicStatuses");
      const topicScheduledStatuses = Messenger.reqres.request("kb:publishable:topic:statuses");
      let allowResponseStatus = false;
      let showResponseStatusReport = false;
      let selectedDepartments = [];
      let selectedTaskChangeTypes = [];
      let selectedTaskOwners = [];
      let selectedTaskPriorities = [];
      let selectedTopicEditStatuses = [];
      let selectedUsers = [];
      let showDepartments = false;
      let showTaskChangeTypes = false;
      let showTaskOwners = false;
      let showTaskPriorities = false;
      let showTopicEditStatuses = false;
      let showUsers = false;
      let taskChangeTypes = null;
      let taskPriorities = null;
      let topicEditStatuses = null;
      let showTask = false;
      let selectedTask = null;
      let optional = false;
      let optionalLanguages = false;
      let optionalTopic = false;
      let optionalTouchpoints = false;
      let selectedAgents = [];
      let showAnalyticsTags = false;
      let selectedAnalyticsTags = [];
      let showArchivedTopics = false;
      let archivedTopicsOptions = [];
      let selectedArchivedTopicOption = Messenger.reqres.request("archivedTopics:options:default");

      for (let i = 0; i < configEntries.length; i++) {
        optional = false;
        let paramUrl = configEntries[i].paramUrl;
        if (paramUrl.indexOf("=") > 0) {
          paramUrl = paramUrl.split("=")[1];
          optional = true;
        }

        switch (paramUrl) {
          case "{startDate}":
          case "{startDateDashHour}":
          case "{startDateDashDay}":
          case "{startDateDashWeek}":
          case "{startDateDashMonth}":
          case "{startDateDashYear}":
          case "{startDateFirstOfYear}":
            //Set the start date as expected
            hasStartDate = true;
            startDate = configEntries[i].paramValue;
            break;
          case "{endDate}":
          case "{endDateDashHour}":
          case "{endDateDashDay}":
          case "{endDateDashWeek}":
          case "{endDateDashMonth}":
          case "{endDateDashYear}":
            //Set the end date as expected
            hasEndDate = true;
            endDate = configEntries[i].paramValue;
            break;
          case "{startDateMonthly}":
            hasStartDate = true;
            startDate = configEntries[i].paramValue;
            limitToMonths = true;
            break;
          case "{endDateMonthly}":
            hasEndDate = true;
            endDate = configEntries[i].paramValue;
            limitToMonths = true;
            break;
          case "{startDateMonth}":
            //If it has a real start date, go ahead and set it. Else we need to set based on the month and year
            hasStartDate = true;
            if (configEntries[i].paramValue.length > 3) {
              //It's a real date
              startDate = configEntries[i].paramValue;
            } else {
              startDateMonth = configEntries[i].paramValue;
              if (startDateYear) {
                startDate = Moment({
                  year: startDateYear,
                  month: startDateMonth,
                })
                  .startOf("month")
                  .valueOf();
              }
            }
            limitToMonths = true;
            break;
          case "{startDateYear}":
            hasStartDate = true;
            if (configEntries[i].paramValue.length > 5) {
              //It's a real date
              startDate = configEntries[i].paramValue;
            } else {
              startDateYear = configEntries[i].paramValue;
              if (startDateMonth) {
                startDate = Moment({
                  year: startDateYear,
                  month: startDateMonth,
                })
                  .startOf("month")
                  .valueOf();
              }
            }
            limitToMonths = true;
            break;
          case "{endDateMonth}":
            //If it has a real end date, go ahead and set it. Else we need to set based on the month and year
            hasEndDate = true;
            if (configEntries[i].paramValue.length > 3) {
              //It's a real date
              endDate = configEntries[i].paramValue;
            } else {
              endDateMonth = configEntries[i].paramValue;
              if (endDateYear) {
                endDate = Moment({
                  year: endDateYear,
                  month: endDateMonth,
                })
                  .endOf("month")
                  .valueOf();
              }
            }
            limitToMonths = true;
            break;
          case "{endDateYear}":
            hasEndDate = true;
            if (configEntries[i].paramValue.length > 5) {
              //It's a real date
              endDate = configEntries[i].paramValue;
            } else {
              endDateYear = configEntries[i].paramValue;
              if (endDateMonth) {
                endDate = Moment({
                  year: endDateYear,
                  month: endDateMonth,
                })
                  .endOf("month")
                  .valueOf();
              }
            }
            limitToMonths = true;
            break;
          case "{matchType}":
            hasMatchType = true;
            matchType = configEntries[i].paramValue;
            break;
          case "{statusId}":
            hasStatusId = true;
            statusId = configEntries[i].paramValue;
            break;
          case "{touchpoint}":
            hasTouchpoints = true;
            optionalTouchpoints = optional;
            if (configEntries[i].paramValue !== "kbDefault") {
              selectedTouchpoint = configEntries[i].paramValue;
              selectedTouchpoints = selectedTouchpoint.split("_");
            } else if (optional) {
              selectedTouchpoints = [];
            } else {
              selectedTouchpoints = [Messenger.reqres.request("default:touchpoint")];
            }
            break;
          case "{agentTransition}":
            hasStandardResponses = true;
            selectedStandardResponse = configEntries[i].paramValue;
            break;
          case "{categories}":
          case "{catVal}":
            hasCategories = true;
            this.catVal = Number(configEntries[i].paramValue);
            break;
          case "{snippetId}":
            hasSnippet = true;
            snippetId = configEntries[i].paramValue;
            break;
          case "{topic}":
            hasTopic = true;
            optionalTopic = optional;
            topic = configEntries[i].paramValue;
            break;
          case "{escalation}":
            escalation = configEntries[i].paramValue;
            break;
          case "{interval}":
            hasIntervals = true;
            interval = configEntries[i].paramValue;
            break;
          case "{language}":
            hasLanguages = true;
            optionalLanguages = optional;
            configEntries[i].paramValue ??= "kbDefault";
            if (configEntries[i].paramValue !== "kbDefault") {
              selectedLanguages = configEntries[i].paramValue.split("_")[0];
            } else if (optional) {
              selectedLanguages = [];
            } else {
              selectedLanguages = [Messenger.reqres.request("default:response:language")];
            }
            break;
          case "{languages}":
            hasLanguages = true;
            hasMultipleLanguages = true;
            optionalLanguages = optional;
            if (configEntries[i].paramValue !== "kbDefault") {
              selectedLanguages = configEntries[i].paramValue.split("_");
            } else if (optional) {
              selectedLanguages = [];
            } else {
              selectedLanguages = [Messenger.reqres.request("default:response:language")];
            }
            break;
          case "{agent}":
            hasAgents = true;
            if (configEntries[i].paramValue) {
              selectedAgents = ReportUtilities.parseAgentParam(configEntries[i].paramValue);
            } else {
              selectedAgents = [];
            }
            break;
          case "{abbreviated}":
            hasAbbreviatedOption = true;
            if (configEntries[i].paramValue === "true") {
              isAbbreviated = true;
            }
            break;
          case "{includeFinished}":
            showIncludeFinished = true;
            if (configEntries[i].paramValue === "true") {
              isFinished = true;
            }
            break;
          case "{reasonWithOrWithout}":
            reasonWithOrWithout = configEntries[i].paramValue;
            break;
          case "{bucket}":
            bucket = configEntries[i].paramValue;
            break;
          case "{surveyChoice}":
            surveyChoice = configEntries[i].paramValue;
            break;
          case "{showBlankResponses}":
            hasShowBlankResponses = true;
            if (configEntries[i].paramValue === "true") {
              isShowBlankResponses = true;
            }
            break;
          case "{topicStatuses}":
            hasTopicStatuses = true;
            allowResponseStatus = true;
            if (!configEntries[i].paramValue || configEntries[i].paramValue === "all") {
              selectedTopicStatuses = _.map(topicStatuses, function (topicStatus) {
                return topicStatus.statusId;
              });
            } else {
              selectedTopicStatuses = configEntries[i].paramValue.split("_");
            }
            break;
          case "{topicScheduledStatuses}":
            showTopicScheduledStatuses = true;
            if (!configEntries[i].paramValue || configEntries[i].paramValue === "all") {
              selectedTopicScheduledStatuses = _.map(
                topicScheduledStatuses,
                function (topicScheduledStatus) {
                  return topicScheduledStatus.statusId;
                },
              );
            } else {
              selectedTopicScheduledStatuses = configEntries[i].paramValue.split("_");
            }
            break;
          case "{departments}":
            showDepartments = true;
            if (configEntries[i].paramValue) {
              selectedDepartments = configEntries[i].paramValue.split("_");
            }
            break;
          case "{taskChangeTypes}":
            showTaskChangeTypes = true;
            if (configEntries[i].paramValue) {
              selectedTaskChangeTypes = configEntries[i].paramValue.split("_");
            }
            taskChangeTypes = Messenger.reqres.request("task:changeTypes");
            break;
          case "{taskOwners}":
            showTaskOwners = true;
            if (configEntries[i].paramValue) {
              selectedTaskOwners = configEntries[i].paramValue.split("_");
            }
            break;
          case "{taskPriorities}":
            showTaskPriorities = true;
            if (configEntries[i].paramValue) {
              selectedTaskPriorities = configEntries[i].paramValue.split("_");
            }
            taskPriorities = Messenger.reqres.request("task:priorities");
            break;
          case "{topicEditStatuses}":
            showTopicEditStatuses = true;
            if (configEntries[i].paramValue) {
              selectedTopicEditStatuses = configEntries[i].paramValue.split("_");
            }
            topicEditStatuses = Messenger.reqres.request("topicEdit:statuses");
            break;
          case "{users}":
            showUsers = true;
            if (configEntries[i].paramValue) {
              selectedUsers = configEntries[i].paramValue.split("_");
            }
            break;
          case "{task}":
            showTask = true;
            if (configEntries[i].paramValue) {
              selectedTask = +configEntries[i].paramValue;
            }
            break;
          case "{analyticsTags}":
            showAnalyticsTags = !!Messenger.reqres
              .request("active:tenant")
              .get("analyticsTagSessionAttribute");
            if (configEntries[i].paramValue) {
              selectedAnalyticsTags = configEntries[i].paramValue.split("_");
            }
            break;
          case "{archivedTopics}":
            showArchivedTopics = true;
            archivedTopicsOptions = Messenger.reqres.request("archivedTopics:options");
            break;
        }
      }
      for (let r = 0; r < report.componentReports.length; r++) {
        if (isChart(report.componentReports[r].type, report.componentReports[r].href)) {
          showDownloadCharts = true;
        }
      }
      if (isChart(report.type, report.href)) {
        showDownloadCharts = true;
      }
      this.set({
        touchpoints: Messenger.reqres.request("kb:touchpoints"),
        authoringStatuses: Messenger.reqres.request("kb:mart:statuses"),
        categories: Messenger.reqres.request("kb:categories"),
        languages: Messenger.reqres.request("kb:languages"),
        agents: Messenger.reqres.request("kb:agents"),
        topicStatuses: topicStatuses,
        topicScheduledStatuses: topicScheduledStatuses,
        standardResponsesType: hasStandardResponses
          ? Messenger.reqres.request("kb:standardResponsesType")
          : null,
        categoryValues: null,
        showCategories: hasCategories,
        showTouchpoints: hasTouchpoints,
        showStandardResponses: hasStandardResponses,
        showIntervals: hasIntervals,
        showLanguages: hasLanguages,
        showMultipleLanguages: hasMultipleLanguages,
        showTopic: hasTopic,
        showSnippet: hasSnippet,
        showStartDate: hasStartDate,
        showEndDate: hasEndDate,
        showMatchType: hasMatchType,
        matchType: matchType,
        showStatusId: hasStatusId,
        statusId: statusId,
        interval: interval,
        showAgents: hasAgents,
        selectedTouchpoints: selectedTouchpoints, //set selected touchpoint to the default
        selectedStandardResponse: selectedStandardResponse,
        selectedLanguages: selectedLanguages,
        selectedCategory: this.catVal,
        selectedSites: selectedSites,
        snippetId: snippetId,
        topic: topic,
        hasAbbreviatedOption: hasAbbreviatedOption,
        isAbbreviated: isAbbreviated,
        hasConfigEntries: hasConfigEntries,
        showDownloadCharts: showDownloadCharts,
        limitToMonths: limitToMonths,
        limitToYears: limitToYears,
        showFinished: showIncludeFinished,
        isFinished: isFinished,
        selectedSnippetName: "",
        selectedTopicName: "",
        reasonWithOrWithout: reasonWithOrWithout,
        reasonWithOrWithoutDisplay: "",
        bucket: bucket,
        surveyChoice: surveyChoice,
        surveyChoiceDisplay: "",
        catVal: catVal,
        catValDisplay: catValDisplay,
        category: category,
        escalation: escalation,
        topicCount: 0,
        hasShowBlankResponses: hasShowBlankResponses,
        isShowBlankResponses: isShowBlankResponses,
        showTopicStatuses: hasTopicStatuses,
        showTopicScheduledStatuses: showTopicScheduledStatuses,
        allowResponseStatus: allowResponseStatus,
        responseStatusReportSelected: showResponseStatusReport,
        selectedTopicStatuses: selectedTopicStatuses,
        selectedTopicScheduledStatuses: selectedTopicScheduledStatuses,
        kbId: kbId,
        departments: null,
        selectedDepartments: selectedDepartments,
        selectedTaskChangeTypes: selectedTaskChangeTypes,
        selectedTaskOwners: selectedTaskOwners,
        selectedTaskPriorities: selectedTaskPriorities,
        selectedTopicEditStatuses: selectedTopicEditStatuses,
        selectedUsers: selectedUsers,
        showDepartments: showDepartments,
        showTaskChangeTypes: showTaskChangeTypes,
        showTaskOwners: showTaskOwners,
        showTaskPriorities: showTaskPriorities,
        showTopicEditStatuses: showTopicEditStatuses,
        showUsers: showUsers,
        taskChangeTypes: taskChangeTypes,
        taskPriorities: taskPriorities,
        topicEditStatuses: topicEditStatuses,
        users: null,
        showTask: showTask,
        selectedTask: selectedTask,
        selectedTaskName: "",
        optionalLanguages: optionalLanguages,
        optionalTopic: optionalTopic,
        optionalTouchpoints: optionalTouchpoints,
        selectedAgents: selectedAgents,
        showAnalyticsTags: showAnalyticsTags,
        selectedAnalyticsTags: selectedAnalyticsTags,
        showArchivedTopics: showArchivedTopics,
        selectedArchivedTopicOption: selectedArchivedTopicOption,
        archivedTopicsOptions: archivedTopicsOptions,
        analyticsTags: null,
      });
      if (showDepartments) {
        const departments = Messenger.reqres.request("kb:departments", { kbId: kbId });
        departments.onSynced(function () {
          this.set("departments", departments);
        }, this);
      }
      if (showTaskOwners || showUsers) {
        kb.onSynced(function () {
          const tenantId = kb.get("tenantId");
          if (showTaskOwners || showUsers) {
            const users = Messenger.reqres.request("tenant:users", tenantId);
            users.onSynced(function () {
              this.set("users", users);
            }, this);
          }
        }, this);
      }
      if (showAnalyticsTags) {
        const analyticsTags = Messenger.reqres.request("report:analyticsTags");
        analyticsTags.onSynced(() => {
          this.set("analyticsTags", analyticsTags);
        });
      }
      this.setStartDate(startDate);
      this.setEndDate(endDate);
    },
    setStartDate: function (startDateTimestamp) {
      let startDayTime;
      startDateTimestamp = parseInt(startDateTimestamp, 10);
      if (this.get("limitToYears")) {
        startDayTime = Moment(startDateTimestamp).startOf("year").valueOf();
      } else if (this.get("limitToMonths")) {
        startDayTime = Moment(startDateTimestamp).startOf("month").valueOf();
      } else {
        startDayTime = Moment(startDateTimestamp).startOf("day").valueOf();
      }
      this.set("startDate", startDayTime);
      return startDayTime;
    },
    setEndDate: function (endDateTimestamp) {
      let endDayTime;
      endDateTimestamp = parseInt(endDateTimestamp, 10);
      if (this.get("limitToYears")) {
        endDayTime = Moment(endDateTimestamp).endOf("year").valueOf();
      } else if (this.get("limitToMonths")) {
        endDayTime = Moment(endDateTimestamp).endOf("month").valueOf();
      } else {
        endDayTime = Moment(endDateTimestamp).endOf("day").valueOf();
      }
      this.set("endDate", endDayTime);
      return endDayTime;
    },
  });
  return ConfigAreaModel;
});
